import axios from 'axios';

import routes from 'app/routes';

export default {
  update: (memberId, values, withFormData, successCallback, errorCallback) => {
    if (withFormData) {
      const formData = new FormData();

      if (typeof values.avatar === 'string') {
        delete values.avatar;
      }

      Object.keys(values).forEach((key) => {
        formData.append(`member[${key}]`, values[key] === null ? '' : values[key]);
      });

      axios
        .put(routes.api.members.profile.update(memberId), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((resp) => {
          successCallback(resp.data.data);
        }).catch((error) => {
          errorCallback(error.response.data);
        });
    } else {
      axios
        .put(routes.api.members.profile.update(memberId), { member: values })
        .then((resp) => {
          successCallback(resp.data.data);
        }).catch((error) => {
          errorCallback(error.response.data);
        });
    }
  },

  updateCareerHistory: (memberId, values, callback) => {
    axios
      .put(routes.api.members.profile.updateCareerHistory(memberId), { data: values })
      .then(() => {
        callback();
      });
  },

  loadActivity: (lastId, successCallback) => {
    axios
      .get(routes.api.members.activities.index, {
        params: {
          last_id: lastId,
        },
      })
      .then((resp) => {
        successCallback(resp.data.data);
      });
  },

  loadFeedbacks: (lastId, successCallback) => {
    axios
      .get(routes.api.members.ratings.index, {
        params: {
          last_id: lastId,
        },
      })
      .then((resp) => {
        successCallback(resp.data.data);
      });
  },

};
